const page = `

{settings}
document.title: Rickard Söderberg
og.title: Rickard Söderberg
og.image: http://quickshot.imgix.net/opinionsbildaren-rickard-soderberg/RickardStill5.png?w=1000&auto=format
og.twitterImage: http://quickshot.imgix.net/opinionsbildaren-rickard-soderberg/RickardStill5.png?h=120&w=120&auto=format&fit=crop
og.description: Han är Sveriges mest färgstarka tenor och hyllar alla former av kärlek. Operasångaren Rickard Söderberg har ett uppdrag - att förändra samhällsklimatet
og.url: http://pejl.svt.se/opinionsbildaren-rickard-soderberg
siteCatalyst.name: opinionsbildaren-rickard-soderberg
siteCatalyst.category: lyxartikel
{}
[+page]
{.div}
  style.position:relative
  style.backgroundColor: black
  style.color:white
  style.height: 100%;
  style.marginBottom: -18px;
  [.+content]
  
  
    {.div}
      style.minHeight:70vh
      style.position:relative
      style.paddingBottom:25px
      [.+content]
        {.div}
          style.position:relative
          style.width: 300px
          style.height:45px
          style.top:20px
          style.backgroundImage: url('http://quickshot.imgix.net/annika-beijbom/ob-1-rad-vit-ht_720.png')
          style.backgroundPositionY: 50%
          style.backgroundPositionX: 0%
          style.backgroundSize: cover
          [.+content]
          []
        {}
        
        luft:-50
          rubrik3: Rickard Söderberg
          
          {.video}
            id:13794824?autostart=true
            storlek:wide
          {}
          {.citat}    
            citat: I slutändan är den stora och enda frågan att vi ska få vara dem vi är.
            cstyle.color:#ddd
          {}
               
      []
    {}
    
    
   
   
 
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-rickard-soderberg/RickardStill1.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 50% 50%
      [.+content]
      []
    {}
    
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: TENOREN

Han är Sveriges mest färgstarka tenor och hyllar alla former av kärlek. Operasångaren Rickard Söderberg har ett uppdrag - att förändra samhällsklimatet

Rickard är född och uppvuxen i en villaförort till Halmstad. Han är sladdbarn och yngst i en syskonskara om fyra. Ett ensambarn med stort behov av eget utrymme.

Hans mamma arbetade som dagmamma. Pappa var företagsledare och ofta bortrest. 

Skolgången var tuff för Rickard, som i tredje klass började sminka sig och bära rosa kläder. Han drömde om att bli sminkös och satte ofta upp små teaterföreställningar i hemmet.

I dag är han en hyllad tenor som uppträtt på de stora operahusen runt om i världen. Han är en flitig bloggare och debattör och vänder sig mot inskränkthet och intolerans.

Med över 200 resdagar om året har hemmet blivit en väldigt viktig plats för Rickard. 

– Att få sitta hemma och bygga Lego är det bästa sättet av varva ner, berättar han.


            luft:
          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13795084
          storlek:wide

        {}
        {.citat}    
          citat: Mitt hem är en fristad för mig. I mitt hem – där jag bor väldigt skyddat och hemligt – kan ingenting hända mig.
          cstyle.color:#ddd
        {}
      []
    {}
    

   
    {.bild}
      fil: opinionsbildaren-rickard-soderberg/RickardKyss.jpg
      storlek: normal
      foto: Rickard Söderberg

    {}
    
    
    
    luft:100
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: AKTIVISTEN
Rickard Söderberg har en stark röst. Dels som tenor runt om i världen, men lika ofta när han ryter ifrån mot homofobi, klimathot och intolerans. 

– Det som skrämmer mig är den suggestiva kraften i religion, hederskultur och inom vissa partier. När våldsamma och livsfarliga åsikter manifesteras och driver på hatet, säger han.

Under åren har han arbetat parlamentariskt och suttit med i kulturnämnder. Men han tycker att han får mer uträttat som radikal aktivist i kampen för det kärleksfulla samhälle han strävar efter.

När en imam 2015 gick ut och sa att homosexualitet var ett virus, valde Rickard att ta en kyssbild med sin man utanför moskén med uppmaningen att prata om saken över en kopp kaffe. 

Han får mycket kärlek av sina följare, men lever också med ett ständigt hot över sig. Sedan en tid tillbaka bor han på hemlig adress med sin man Anders.

– När man för femte gången torkar bort bajs från sin cykel, eller när någon eldat upp regnbågsflaggan man hängt upp, eller när man får ännu ett hatbrev, då är det klart att det känns.

Men han tänker inte låta sig tystas och han har ett nära samarbete med polisens hatbrottsgrupp. Tillsammans går de igenom nya dödshot och försöker hitta vägar att nå framåt.


            luft:

          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13795116
          storlek:wide
        {}
        {.citat}    
          citat: Grejen med att klä ut sig är inte att man blir någon annan – man blir en annan del av sig själv.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-rickard-soderberg/RickardStill3.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 50% 50%
      [.+content]
      []
    {}
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: SUPERHJÄLTEN

Rickard ser sig själv som en Anne på Grönkulla om dagen och som en superhjälte om natten. Romantisk, stillsam och snäll, men redo att kasta på sig manteln när det behövs.

– Jag ser mig sällan som modig, det är snarare en övertygelse om att agera för det samhälle jag vill ha. Min roll som opinionsbildare är värdefull och ska banne mig användas, säger han.

Han visste tidigt vad han ville göra. Redan i sjunde klass hoppade Rickard av skolan och tentade av åttan, nian och hela gymnasiet för att kunna studera musik på heltid.

– På så sätt slapp jag den fruktansvärda sociala biten i skolan, att sticka ut är inte alltid lätt.

Rickard spelade mycket piano hemma och är ursprungligen utbildad pianist. Efter sina studier vid operaakademin i Köpenhamn inledde han sin sångkarriär som tenor.

I dag gör han sin röst hörd i många olika sammanhang med sin sprudlande personlighet och de karaktäristiska svartmålade ögonen. 

            
            luft:

          []
        {}
      []
    {}
    
    
    
    
     {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13795048
          storlek:wide
        {}
        {.citat}    
          citat: Jag började sminka mig redan i lågstadiet. Lite puder, lite mascara. Väldigt diskret, för jag visste att ju mer det syntes, desto mer stryk fick jag.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
     {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-rickard-soderberg/RickardStill4.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 50% 50%
      [.+content]
      []
    {}
    
    
     {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: TRYGGHETEN

Han har lyft situationen för Rysslands HBTQ-personer. Han har också krävt att svenska ambassaden i Moskva skulle hissa regnbågsflaggan under Stockholm Pride.

Men den ruffa samtalstonen och det hårda samhällsklimatet har också bidragit till en viss självcensur. I dag överväger han noga vad han säger och hur han säger det.

– Det finns så många som gärna vill missförstå det jag säger och det har jag inte råd att bjuda på. Jag hatar det, men det är också en överlevnadsinstinkt som jag måste omfamna.

Familjen och den inre vänskapskretsen har därför blivit extra viktig för Rickard under åren.

– Med dem kan jag tillåta mig att vara ärlig och ännu mer sårbar och ömtålig än jag kan vara i andra sammanhang, säger han.

En annan plats Rickard känner sig hemma på är scenen. Där har han alltid varit mer accepterad än utanför. Där får han också utlopp för sin kreativitet och lust.


            luft:

          []
        {}
      []
    {}
    
    
    
     {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id: 13795112
          storlek:wide
        {}
        {.citat}    
          citat: Scenen är alltid en plats där jag känner mig trygg. Jag har mitt hantverk, jag vet vad jag kan.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
        
   
    
    
    {.div}
        style.backgroundColor: #eee
        style.color:#111
        style.maxWidth: 600px
        style.padding: 1px 12px
        style.margin: 24px auto 0
        [.+content]
           mellanrubrik: OM RICKARD SÖDERBERG
           
          {.bild}
            fil:opinionsbildaren-rickard-soderberg/RickardStill5.png
            storlek:m
          {}
          
          [Namn:] John Rickard Söderberg.
          [Född:] April 1975 i Halmstad.
          [Familj:] Maken Anders.
          [Bor:] Malmö.
          [Gör:] Svensk operasångare (tenor) och debattör. Engagerad i HBTQ-frågor och har vid flera tillfällen tagit ställning i miljöfrågor genom exempelvis minskat köttätande. Genomförde 2008 en nytolkning av ”Till havs” tillsammans med Greenpeace. Driver blogg som fokuserar på miljö, HBTQ och kulturfrågor.
          Han har varit programledare för ”Gatans kör” i SVT - ett program där Rickard bygger upp en kör bestående av människor i samhällets utkanter.
          [Gör på fritiden:] Jag har typ ingen fritid, går upp tidigt på morgonen och har inga riktiga fritidsintressen, lite rollspel med mina kompisar ibland.
          [Oanade talanger:] En jäkel på Photoshop. Det började som en lek men nu sitter jag och redigerar pressbilder på mig själv som ska ut. Arbetar just nu på en bok tillsammans med en vän där vi har ganska hårt retuscherade kitschiga bilder. 
          [Senast lästa bok:]  På nattduksbordet just nu ligger ”Romantiska rendezvous” - en bok om 1800-talets primadonnor i Norditalien. En operaprimadonnebok.
          [Förebilder:] Har en massa förebilder, på väggen hemma hänger tre stycken: Först är det Maria Callas - som står för någons slags konstnärlig total integritet, sedan är det Aung San Suu Kyi - som är lite tveksam ju längre tiden går, men som under en lång tid har stått för en stark frihetskamp. Sedan RuPaul, som är den ultimata formen av kreativitet i att uttrycka sig som den man är.
          [Favoritcitat:] Gandhi: ”Be the change that you wish to be.”

          luft:
        []
      {}
      
      
      
    
    
    luft:200
    
    rubrik5:Reporter: Magnus Nilsson
    rubrik5:Fotograf: Åke Wehrling
    rubrik5:[SVT Opinion | http://www.svt.se/opinion/om-opinionsbildaren | white | target:_self  ]
    
    {.sharebuttons}
    title: Rickard Söderberg
    url: http://pejl.svt.se/opinionsbildaren-rickard-soderberg/
    {}
       
    luft:100
   
  []
{}



[]
`;

export default page;





/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/opinionsbildaren-rickard-soderberg.js
 **/